define('SkuPlpAdd.View', [
    'sku_plp_add.tpl',
    'Backbone',
    'Utils'
], function SkuPlpAddView(
    skuPlpAddTpl,
    Backbone
) {
    'use strict';

    return Backbone.View.extend({

        template: skuPlpAddTpl,
        contextDataRequest: ['item'],
        getContext: function getContext() {
            var item = this.contextData.item();

            return {
                sku: item.itemid
            };
        }
    });
});
